import { render } from "./PublicBookingBlockDialog.vue?vue&type=template&id=a7d73d78&scoped=true"
import script from "./PublicBookingBlockDialog.vue?vue&type=script&lang=js"
export * from "./PublicBookingBlockDialog.vue?vue&type=script&lang=js"

import "../../assets/css/staff-editor-dialog.css?vue&type=style&index=0&id=a7d73d78&scoped=true&lang=css&external"
import "./PublicBookingBlockDialog.vue?vue&type=style&index=1&id=a7d73d78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7d73d78"]])

export default __exports__